module.exports = __webpack_public_path__ + "img/ysgj_015@2x.40af89af.png";